import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
export const useSortingOptions = () => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  return useMemo(() => {
    return [{
      label: t('amadeusRatingSection.sorting.options.latestReviews'),
      value: 'latest'
    }, {
      label: t('amadeusRatingSection.sorting.options.bestReviews'),
      value: 'ratingDesc'
    }, {
      label: t('amadeusRatingSection.sorting.options.worstReviews'),
      value: 'ratingAsc'
    }, {
      label: t('amadeusRatingSection.sorting.options.travelMonth'),
      value: 'travelTime'
    }, {
      label: t('amadeusRatingSection.sorting.options.youngToOld'),
      value: 'ageAsc'
    }, {
      label: t('amadeusRatingSection.sorting.options.oldToYoung'),
      value: 'ageDesc'
    }];
  }, [t]);
};